import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { CarregadoresMoneyInput } from "@/components/CarregadoresMoneyInput";
import { formatBrazilianCurrency } from "@/utils/formatters";
import type { SavePgtoTipo } from "@/utils/saveCondominiosPropostaUtils";
import { saveValorEtapaEmReais } from "@/utils/saveCondominiosPropostaUtils";

type SaveEtapaPagamentoFieldProps = {
  id: string;
  label: string;
  tipo: SavePgtoTipo;
  valor: number;
  valorTotal: number;
  onTipoChange: (tipo: SavePgtoTipo) => void;
  onValorChange: (valor: number) => void;
};

export function SaveEtapaPagamentoField({
  id,
  label,
  tipo,
  valor,
  valorTotal,
  onTipoChange,
  onValorChange,
}: SaveEtapaPagamentoFieldProps) {
  const emReais = saveValorEtapaEmReais(valor, tipo, valorTotal);

  const handleTipoChange = (novoTipo: SavePgtoTipo) => {
    if (novoTipo === tipo) return;
    const total = Math.max(0, Number(valorTotal) || 0);
    if (novoTipo === "reais") {
      onValorChange(saveValorEtapaEmReais(valor, "percentual", total));
    } else {
      const reais = saveValorEtapaEmReais(valor, "reais", total);
      onValorChange(total > 0 ? Math.round((reais / total) * 10000) / 100 : 0);
    }
    onTipoChange(novoTipo);
  };

  return (
    <div className="space-y-2 rounded-lg border p-3">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <Label className="text-sm font-medium">{label}</Label>
        <div className="flex gap-1">
          <Button
            type="button"
            size="sm"
            variant={tipo === "percentual" ? "default" : "outline"}
            className="h-7 px-2 text-xs"
            onClick={() => handleTipoChange("percentual")}
          >
            %
          </Button>
          <Button
            type="button"
            size="sm"
            variant={tipo === "reais" ? "default" : "outline"}
            className="h-7 px-2 text-xs"
            onClick={() => handleTipoChange("reais")}
          >
            R$
          </Button>
        </div>
      </div>
      {tipo === "reais" ? (
        <CarregadoresMoneyInput
          id={`${id}-reais`}
          label="Valor (R$)"
          value={valor}
          onValueChange={onValorChange}
        />
      ) : (
        <div className="space-y-1">
          <Input
            id={`${id}-pct`}
            type="number"
            min={0}
            max={100}
            step={0.01}
            value={valor === 0 ? "" : valor}
            placeholder="0"
            onChange={(e) => {
              const n = parseFloat(e.target.value);
              onValorChange(Number.isFinite(n) && n >= 0 ? n : 0);
            }}
          />
          <p className="text-xs text-muted-foreground">
            Equivale a {formatBrazilianCurrency(emReais)}
          </p>
        </div>
      )}
    </div>
  );
}
